<template>
  <div>
    <el-alert
      title="提示:桥梁博士V3.6版本包含3.5,方案设计师V5.1包含5.0及4.2版本,单次设置最长90天,每把加密锁不超过三次设置,勾选版本及填写前请认真阅读，这将直接影响生成文件的效率."
      type="warning"
      show-icon
      center
    ></el-alert>
    <el-input placeholder="请输入内容" v-model="danwei">
      <template slot="prepend">试用产品单位名称</template>
    </el-input>
    <el-table :data="tableData" class="tb-edit" style="width: 100%" ref="multipleTable">
      <el-table-column type="selection" width="165"></el-table-column>
      <el-table-column label="产品名称" width="245" prop="moduleName"></el-table-column>
      <el-table-column prop="expiryDate" label="时间">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.expiryDate" clearable placeholder="1-90"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="number" label="次数">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.number" clearable placeholder="1-99999999"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="node" label="节点">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.node" clearable placeholder="0-200"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <div class="box">
      <input
        type="file"
        name="file-1[]"
        id="file-1"
        @input="inputfunc"
        class="inputfile inputfile-1"
        data-multiple-caption="{count} files selected"
        multiple
      />
      <label for="file-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
          <path
            d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
          />
        </svg>
        <span>选择Rac文件&hellip;</span>
      </label>
    </div>
    <el-button
      type="primary"
      @click="savebutton()"
      style="width:150px;"
      v-loading.fullscreen.lock="fullscreenLoading"
      element-loading-text="RAU文件生成中，请稍后..."
    >确认</el-button>
    <el-button
      type="success"
      v-if="play"
      style="width:200px ;height:48px;margin-top:20px ;font-size:1.20rem;font-weight: 600;"
      icon="el-icon-download"
    >
      <a href="#" id="rauget" style="text-decoration:none;color: #f1e5e6;font-weight:700;">下载Rau文件</a>
    </el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fullscreenLoading: false,
      outerVisible: false,
      play: false,
      danwei: "",
      tableData: [],
    };
  },
  mounted() {
    this.$http
      .post(this.$getaxiosurl("/enc/trial/getAllTrialModule"))
      .then((response) => {
        if (response.data.code == "00100") {
          for (var i = 0; i < response.data.data.length; i++) {
            this.tableData.push(response.data.data[i]);
          }
          this.tableData.sort(this.zimusort("moduleName"));
        }
      });
  },
  methods: {
    zimusort(propertyName) {
      return function (object1, object2) {
        var value1 = object1[propertyName];
        var value2 = object2[propertyName];
        if (value1 < value2) {
          return -1;
        } else if (value1 > value2) {
          return 1;
        } else {
          return 0;
        }
      };
    },
    savebutton() {
      let check = this.$refs.multipleTable.selection;
      if (!check.length) {
        return this.$message({
          showClose: true,
          message: "请选择产品",
          type: "error",
        });
      }
      for (let index = 0; index < check.length; index++) {
        if (!this.danwei.length) {
          return this.$message({
            showClose: true,
            message: "请输入试用单位名称",
            type: "error",
          });
        }
        if (check[index].expiryDate > 90) {
          return this.$message({
            showClose: true,
            message: "时间不能大于90天",
            type: "error",
          });
        }
        if (check[index].node > 200) {
          return this.$message({
            showClose: true,
            message: "节点不能大于200",
            type: "error",
          });
        }
        if (check[index].number > 99999999) {
          return this.$message({
            showClose: true,
            message: "次数不能大于99999999",
            type: "error",
          });
        }
        if (
          check[index].hasOwnProperty("node", "expiryDate", "number") == false
        ) {
          return this.$message({
            showClose: true,
            message: "时间,次数,节点不能空",
            type: "error",
          });
        }
      }
      var fileInput = document.getElementById("file-1");
      if (fileInput.files.length <= 0) {
        return this.$message({
          showClose: true,
          message: "请选择RAC文件",
          type: "error",
        });
      }
      this.fullscreenLoading = true;
      let formData = new FormData();
      formData.append("modules", JSON.stringify(check));
      formData.append("companyName", this.danwei);
      formData.append("racFile", fileInput.files[0], fileInput.files[0].name);
      this.$http
        .post(this.$getaxiosurl("/enc/trial/genEncryptRecord"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.fullscreenLoading = false;
            this.play = true;
            setTimeout(() => {
              let rau = document.getElementById("rauget");
              rau.href = response.data.rauFile;
              this.$message({
                message: "Rau文件已生成",
                type: "success",
              });
            }, 0);
          } else {
            this.fullscreenLoading = false;
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    inputfunc() {
      var inputs = document.querySelectorAll(".inputfile");
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
          labelVal = label.innerHTML;
        input.addEventListener("change", function (e) {
          var fileName = "";
          if (this.files && this.files.length > 1)
            fileName = (
              this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
          else fileName = e.target.value.split("\\").pop();
          if (fileName) label.querySelector("span").innerHTML = fileName;
          else label.innerHTML = labelVal;
        });
      });
    },
  },
};
</script>
<style scoped>
h3 {
  text-align: center;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  z-index: -1;
}
.inputfile + label {
  max-width: 80%;
  font-size: 1.25rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.625rem 1.25rem;
}
.inputfile + label svg {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.25em;
}
.inputfile-1 + label {
  color: #f1e5e6;
  background-color: #409eff;
}
.inputfile-1:focus + label,
.inputfile-1.has-focus + label,
.inputfile-1 + label:hover {
  background-color: #67c23a;
}
</style>
